// extracted by mini-css-extract-plugin
export var backgroundImage = "basketListItem-module--background-image--Ogj0H";
export var itemDetails = "basketListItem-module--item-details--QgRHK";
export var listItem = "basketListItem-module--list-item--TKAjx";
export var price = "basketListItem-module--price--ovF-a";
export var priceDescription = "basketListItem-module--price-description--Dfl7E";
export var quantityConfirmButton = "basketListItem-module--quantity-confirm-button--kb0-a";
export var quantitySelectorWrapper = "basketListItem-module--quantity-selector-wrapper--31I5A";
export var removeButton = "basketListItem-module--remove-button--KmIjn";
export var title = "basketListItem-module--title--JSG9X";